import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Grid, Button } from '@mui/material';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getClients, importClients } from '../services/api';
import CriarCliente from './criarcliente';
import ConfirmModal from '../warehouse/modals/confirmx';
import FeedbackModal from '../warehouse/modals/FeedbackModal';
import MoradasClient from './MoradasClient';

const ClientesTab = ({ apiBaseURL }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);

  // Estados para as modais de confirmação e feedback
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    getClients()
      .then(response => {
        setClients(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Erro ao obter os clientes:', error);
        setLoading(false);
      });
  }, []);

  if (selectedClient) {
    return (
      <MoradasClient clientId={selectedClient.id} apiBaseURL={apiBaseURL} />
    );
  }

  // Filtra os clientes procurando nas 4 colunas
  const filteredClients = clients.filter(client => {
    const search = searchTerm.toLowerCase();
    return (
      (client.nome2 && client.nome2.toLowerCase().includes(search)) ||
      (client.name && client.name.toLowerCase().includes(search)) ||
      (client.phone && client.phone.toLowerCase().includes(search)) ||
      (client.email && client.email.toLowerCase().includes(search))
    );
  });

  const handleSelectionChange = (e) => {
    
    setSelectedClient(e.value);
    console.log('Cliente selecionado:', e.value);
  };

  // Função que chama a API para importar os clientes do PHC
  const handleImportAPI = async () => {
    try {
      const response = await importClients();
      console.log('Clientes importados:', response.data.imported);
    } catch (error) {
      console.error('Erro ao importar clientes:', error);
      throw error;
    }
  };

  // Função executada após a confirmação do usuário
  const handleConfirmImport = async () => {
    // Fechar a modal de confirmação e mostrar a de feedback
    setConfirmVisible(false);
    setFeedbackVisible(true);
    setIsSubmitting(true);
    setSubmissionComplete(false);
    setErrorMessage(null);

    try {
      await handleImportAPI();
      setSubmissionComplete(true);
      // Se desejado, recarregar a lista de clientes aqui chamando getClients novamente
    } catch (error) {
      setErrorMessage(error.message || 'Erro desconhecido');
    } finally {
      setIsSubmitting(false);
      // Fecha a modal de feedback após 2 segundos
      setTimeout(() => {
        setFeedbackVisible(false);
      }, 2000);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h6" gutterBottom>
            Lista de Clientes
          </Typography>
        </Grid>
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              {/* Botão para criar cliente */}
              <CriarCliente apiBaseURL={apiBaseURL} />
            </Grid>
            <Grid item>
              {/* Botão para actualizar pelo PHC */}
              <Button 
                variant="contained" 
                color="secondary"
                onClick={() => setConfirmVisible(true)}
              >
                Actualizar pelo PHC
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Procurar por cliente"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 2 }}
      />
      <DataTable
        value={filteredClients}
        loading={loading}
        paginator
        rows={10}
        dataKey="id"
        selectionMode="single"
        selection={selectedClient}
        onSelectionChange={handleSelectionChange}
        rowClassName={(data) =>
          selectedClient && selectedClient.id === data.id ? 'selected-row' : ''
        }
      >
        <Column field="nome2" header="Abreviatura" sortable />
        <Column field="name" header="Nome" sortable />
        <Column field="phone" header="Telefone" sortable />
        <Column field="email" header="Email" sortable />
      </DataTable>
      {/* Estilos para hover e seleção de linha */}
      <style>{`
        .p-datatable-tbody > tr:not(.selected-row):hover {
          background-color: #f5f5f5;
        }
        .selected-row {
          background-color: #c8e6c9 !important;
        }
      `}</style>

      {/* Modal de Confirmação */}
      <ConfirmModal
        visible={confirmVisible}
        message="Deseja actualizar os clientes pelo PHC?"
        onConfirm={handleConfirmImport}
        onCancel={() => setConfirmVisible(false)}
      />

      {/* Modal de Feedback */}
      <FeedbackModal
        open={feedbackVisible}
        isSubmitting={isSubmitting}
        submissionComplete={submissionComplete}
        error={errorMessage}
        onClose={() => setFeedbackVisible(false)}
      />
    </Box>
  );
};

export default ClientesTab;
